<mat-drawer-container>
  <mat-drawer mode="side" [opened]="sideBarOpen" class="sidebar">
    <!-- <mat-drawer mode="side" opened="true"> -->
    <app-sidenav></app-sidenav>
  </mat-drawer>
  <mat-drawer-content>
    <app-header (toggleSidebarForMe)="sideBarToggler()"></app-header>
    <router-outlet></router-outlet>
    <!-- build = 2c83f9e95c102582245b0508309e5b425726b4c9-19-06-26 13:54:22 -->
  </mat-drawer-content>
</mat-drawer-container>
 